// @flow

import React, { type Node, type ComponentType } from 'react';

type Props = {
  as?: ComponentType<any>,
  className?: string,
  type?: string,
  readOnly?: boolean,
  children?: Node,
};

export function Input({
  as: As = 'input',
  className = 'field__input',
  type = 'text',
  children,
  readOnly,
  ...rest
}: Props): Node {
  return (
    <As {...rest} className={className} type={type} style={{ opacity: readOnly ? '0.4' : '1' }}>
      {children}
    </As>
  );
}
